import TypeToggle from "components/Blocks/TypeToggle/TypeToggle";

export default TypeToggle;
